"use client"

import { useRef, useEffect } from "react"

interface ForcefieldBarProps {
  current: number
  max: number
  scale: number
}

export const ForcefieldBar = ({ current, max, scale }: ForcefieldBarProps) => {
  const percent = max > 0 ? (current / max) * 100 : 0
  const barRef = useRef<HTMLDivElement>(null)

  // Force DOM update when forcefield changes
  useEffect(() => {
    if (barRef.current) {
      barRef.current.style.width = `${percent}%`
    }
  }, [percent])

  // Don't render if hero has no forcefield capacity or forcefield is empty
  // (must come after the hooks - hooks can't be called conditionally)
  if (max <= 0 || current <= 0) return null

  const width = 82 * scale
  const height = 5 * scale // Match health bar height
  const left = 20 * scale
  const top = 119 * scale // Overlaid on top of health bar

  return (
    <div
      id="hero-forcefield-bar"
      className="absolute overflow-hidden"
      style={{
        left,
        top,
        width,
        height,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: 2 * scale,
      }}
    >
      <div
        ref={barRef}
        className="h-full bg-white"
        style={{ width: `${percent}%`, transition: "width 0.1s ease-out" }}
      />
    </div>
  )
}
